import { IBasicItem } from "@mctypes/global.types";
import { IRegister } from "@mctypes/register.types";
import React, { useEffect, useState } from "react";
import ConnectExistingItemModal from "../components/ConnectExistingItemModal/ConnectExistingItemModal";
import { useAppSelector } from "../hooks";
import { MCApplicationsUrlEnum } from "../mc-shared/sharedConstants";
import { doGetIssueBoardsDepricated } from "./routes/issuesApp/IssueBoardApiDepricated";
import { doGetBasicIssueInfo } from "./routes/issuesApp/issueAPIDepricated";

const ConnectExistingIssueToItemModalWrapper: React.FC<{
  opened: boolean;
  projectId: string;
  defaultIssueBoard?: { name: string; _id: string };
  onConnected: (boardId: string, issueId: string) => void;
  closeModal: () => void;
  blockedIssueIds?: string[];
  allowedTypes?: Array<"ISSUE" | "TASK">;
  description?: string;
  requireConfirmation?: boolean;
  confirmationLabel?: string;
}> = ({
  opened,
  projectId,
  onConnected,
  closeModal,
  blockedIssueIds = [],
  defaultIssueBoard,
  allowedTypes,
  description,
  requireConfirmation,
  confirmationLabel,
}) => {
  const [selectedIssueBoard, setSelectedIssuseBoard] = useState<IRegister.BoardPopulated>(null);
  const [issuesToSelectFrom, setIssuesToSelectFrom] = useState<IBasicItem[]>(null);
  const [issueBoards, setIssueBoards] = useState<IRegister.BoardPopulated[]>(null);
  const apps = useAppSelector((state) => state.globalReducer.apps);

  useEffect(() => {
    init();
  }, [opened]);

  useEffect(() => {
    if (defaultIssueBoard != null && issueBoards?.length > 0) {
      const board = issueBoards?.find((board) => board._id === defaultIssueBoard._id);

      if (board != null) {
        issueBoardWasSelected(board);
      }
    }
  }, [defaultIssueBoard, issueBoards]);

  const init = async () => {
    if (opened !== true) {
      return;
    }

    const _issueBoard = await doGetIssueBoardsDepricated(projectId);
    setIssueBoards(_issueBoard.filter((board) => board.status === "ACTIVE"));
  };

  const issueBoardWasSelected = async (issueBoard: IRegister.BoardPopulated | null) => {
    if (issueBoard == null) {
      setSelectedIssuseBoard(null);
      setIssuesToSelectFrom([]);
      return;
    }

    setSelectedIssuseBoard(issueBoard);
    let _basicTypeAheadItems = await doGetBasicIssueInfo(projectId, issueBoard._id);
    _basicTypeAheadItems = _basicTypeAheadItems.reduce((acc, item) => {
      if (blockedIssueIds.indexOf(item._id) > -1) {
        return acc;
      }
      if (allowedTypes != null && !allowedTypes.includes(item.type as "ISSUE" | "TASK")) {
        return acc;
      }
      acc.push({
        displayValue: `${item.id}: ${item.title}`,
        ...item,
      });
      return acc;
    }, []);
    setIssuesToSelectFrom(_basicTypeAheadItems);
  };

  return (
    <ConnectExistingItemModal
      opened={opened}
      items={issuesToSelectFrom}
      onSelectBoard={issueBoardWasSelected}
      selectedBoard={selectedIssueBoard}
      boards={issueBoards}
      onConnect={onConnected}
      modalTitle="Koble sak"
      description={description}
      requireConfirmation={requireConfirmation}
      confirmationLabel={confirmationLabel}
      toggle={closeModal}
      currentApp={MCApplicationsUrlEnum.ISSUE}
      apps={apps}
      projectId={projectId}
    />
  );
};

export default ConnectExistingIssueToItemModalWrapper;
